import React from "react";
import { Box } from "@mui/material";

const NotFound = () => {
  return (
    <Box
      sx={{
        marginTop: {
          xs: "84px",
          md: "0px",
        },
      }}
    >
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
    </Box>
  );
};

export default NotFound;
